import styled from "styled-components";
import Button from "./Button";
import DownLoadIcon from "../images/download-icon.png";
import { useContext, useEffect, useState } from "react";
import { ILogData } from "../interfaces/log-data-interface";
import DownloadCsv from "../services/DownloadCsv";
import { ReactComponent as HistoryIcon } from "../images/history-icon.svg";
import { googleSheets } from "../apis/google-sheets-api";
import { ISeachQuery } from "../interfaces/search-query-interface";
import { LoadingContext } from "../contexts/LoadingContext";
import { UserContext } from "../contexts/UserContext";
import { DropdownContext } from "../contexts/DropdownContext";
import TableBar from "./TableBar";
import DropdownList from "./Dropdown/DropdownList";
interface ISeachResultBar {
  data: ILogData[];
  searchQuery: ISeachQuery;
}

const SeachResultBar = ({ data, searchQuery }: ISeachResultBar) => {
  const { user } = useContext(UserContext);
  const { setIsLoading } = useContext(LoadingContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { dropdownRef, setDropdownRef } = useContext(DropdownContext);
  const [historyIsOpen, setHistoryIsOpen] = useState(false);
  const [history, setHistory] = useState<
    [] | { label: any; icon: any | undefined }[]
  >([]);
  useEffect(() => {
    if (!isDropdownOpen) {
      setDropdownRef(null);
    } else {
      setDropdownRef("dropdown");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDropdownOpen]);
  useEffect(() => {
    if (!dropdownRef) {
      setIsDropdownOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownRef]);
  const handleGenerateGoogleSheet = async () => {
    if (!user) return;
    setIsDropdownOpen(false);
    setIsLoading({
      status: "inprogress",
      label: "Google sheets generating...",
    });
    const googleSheetUrl = await googleSheets.generate(
      user.idToken,
      user.company,
      searchQuery,
    );
    setHistory([
      {
        label: (
          <div
            style={{ width: "300px" }}
            onClick={() => {
              if (googleSheetUrl.length > 1) {
                window.open(
                  `https://docs.google.com/spreadsheets/u/0/?tgif=d&q=${googleSheetUrl[0].name}`,
                );
              } else if (googleSheetUrl.length === 1) {
                window.open(googleSheetUrl[0].url);
              }
            }}
          >
            <div
              style={{
                width: "300px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontSize: "10px",
              }}
            >
              Downloaded : {googleSheetUrl[0].name}
            </div>
          </div>
        ),
        icon: undefined,
      },
      ...history,
    ]);
    setIsLoading({
      status: googleSheetUrl ? "complete" : "fail",
      label: (
        <SLink
          onClick={() => {
            if (googleSheetUrl.length > 1) {
              window.open(
                `https://docs.google.com/spreadsheets/u/0/?tgif=d&q=${googleSheetUrl[0].name}`,
              );
            } else if (googleSheetUrl.length === 1) {
              window.open(googleSheetUrl[0].url);
            }
          }}
        >
          {googleSheetUrl
            ? "Click here or check your drive to see your Google sheets."
            : "Can not generate google sheet link"}
        </SLink>
      ),
    });
  };
  return (
    <TableBar label={"Search Result"}>
      {data.length ? (
        <SButtonContainer>
          {history.length ? (
            <SHistoryButton
              onClick={() => {
                setHistoryIsOpen(true);
              }}
            >
              <HistoryIcon />
            </SHistoryButton>
          ) : (
            ""
          )}
          <Button
            onclick={() => {
              setIsDropdownOpen(!isDropdownOpen);
            }}
            addonCss={{
              color: "#ffffff",
              background: "#3C7FEC",
              fontWeight: 600,
            }}
          >
            <img alt="" src={DownLoadIcon}></img>
            <SLabelButton>Download</SLabelButton>
          </Button>

          <DropdownList
            dropdownIsOpen={historyIsOpen}
            choices={history}
            dropdownSelected=""
            onclick={(e: string) => {}}
            setDropdownIsOpen={setHistoryIsOpen}
            css={{
              margin: "0px 0px -90px -300px",
              width: "fit-content",
            }}
          />

          {isDropdownOpen && (
            <SDropdownList>
              <SChoice onClick={() => setIsDropdownOpen(false)}>
                <DownloadCsv data={data} />
              </SChoice>
              <SChoice onClick={() => handleGenerateGoogleSheet()}>
                Export to Google Sheets
              </SChoice>
            </SDropdownList>
          )}
        </SButtonContainer>
      ) : (
        ""
      )}
    </TableBar>
  );
};
export default SeachResultBar;
const SHistoryButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 50%;
  cursor: pointer;
  transition:
    background-color var(--transition),
    transform var(--transition),
    border-color var(--transition);
  &:hover {
    background-color: var(--color-primary-soft);
    border-color: var(--color-primary);
    transform: scale(1.03);
  }
`;
const SLink = styled.div`
  cursor: pointer;
  color: var(--color-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
`;
const SChoice = styled.div`
  font-size: 14px;
  color: var(--color-text);
  padding: 10px 16px;
  cursor: pointer;
  border-radius: var(--radius-xs);
  transition:
    background-color var(--transition),
    color var(--transition);
  &:hover {
    background-color: var(--color-primary-soft);
    color: var(--color-primary);
  }
`;
const SDropdownList = styled.div`
  position: absolute;
  width: 220px;
  background: var(--color-surface);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  margin-left: -60px;
  margin-top: 130px;
  padding: 6px;
  z-index: 20;
`;
const SLabelButton = styled.div`
  margin-left: 10px;
`;

const SButtonContainer = styled.div`
  margin-right: 24px;
  position: relative;
  display: flex;
  align-items: center;
`;
